import { v4 as uuid } from 'uuid';

// import media files
import Dennis from 'assets/images/avatar/dennis.png';
import Krzysztof from 'assets/images/avatar/krzysztof.png';

export const QuotesData = [
	/*{
		id: uuid(),
		image: Dennis,
		content: `I see in structured data what remains hidden to others - and translate this into solutions that are really needed. For me, good software starts with a clear understanding of reality.`,
		name: 'Dennis',
		designation: '🎾 🥾 🚴'
	},*/
	{
		id: uuid(),
		image: Krzysztof,
		content: `Marketplace integration is complex - but you wouldn't know it from our SaaS solution. I want haeppy.app to feel as intuitive as if it was made just for you.`,
		name: 'Krzysztof',
		designation: '🛞 🎣 🏋'
	}
];
export default QuotesData;
